import { useL2rMutation, l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

export function useRecoverPasswordMutation(config = {}) {
    const url = "auth/recover_password/"
    return useL2rMutation(url, axiosInstance.post, {}, config)
}
